<template>
  <div class="page-container theme-v3">
    <AppNavbar />
    <router-view />
    <AppFooter />
    <!-- <FloatWindow /> -->
  </div>
</template>

<script>
import AppNavbar from '@/components/navigation/AppNavbar.vue';
import AppFooter from '@/components/navigation/AppFooter.vue';
// import FloatWindow from './components/FloatWindow/index.vue';

export default {
  components: {
    AppNavbar,
    AppFooter,
    // FloatWindow
  }
};
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
  position: relative;
}
</style>
